"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeLog = exports.LogKeys = exports.IkeLogStreamType = exports.IkeLogType = void 0;
exports.LOGKEY = LOGKEY;
const tslib_1 = require("tslib");
const bblog_1 = require("bblog");
const bblog_stream_console_1 = require("bblog-stream-console");
const log_streams_1 = require("./log.streams");
var log_types_1 = require("./log.types");
Object.defineProperty(exports, "IkeLogType", { enumerable: true, get: function () { return log_types_1.IkeLogType; } });
var log_streams_2 = require("./log.streams");
Object.defineProperty(exports, "IkeLogStreamType", { enumerable: true, get: function () { return log_streams_2.IkeLogStreamType; } });
exports.LogKeys = {
    CONSOLE: 'console',
    TYPE: 'type',
    STREAM: 'stream',
    LEVEL: 'level',
    CONFIG: 'config',
};
const REQUIRED_KEYS = [exports.LogKeys.LEVEL, exports.LogKeys.STREAM];
function LOGKEY(type, key) {
    return ['log', type, key].join('.');
}
tslib_1.__exportStar(require("bblog"), exports);
const FACTORIES = {};
class IkeLog extends bblog_1.Log {
    static create(config, type, options) {
        const requiredKeys = REQUIRED_KEYS.map((k) => LOGKEY(type, k));
        if (config.requires(requiredKeys)) {
            throw new Error(`Unable to create logger ${type} missing keys: ` + config.missing(requiredKeys).join(','));
        }
        const streams = [];
        const logLevel = config.getDefaultNumber(LOGKEY(type, exports.LogKeys.LEVEL), 10);
        const logStreamType = config.getString(LOGKEY(type, exports.LogKeys.STREAM));
        const consoleEnabled = LOGKEY(type, exports.LogKeys.CONSOLE);
        if (config.getBoolean(consoleEnabled) && logStreamType !== log_streams_1.IkeLogStreamType.CONSOLE) {
            streams.push(ConsoleStreamFactory.create(logLevel));
        }
        if (logStreamType != null) {
            const configKey = LOGKEY(type, exports.LogKeys.CONFIG);
            const logConfig = config.get(configKey);
            const factory = FACTORIES[logStreamType];
            if (factory == null) {
                throw new Error(`Unable to construct log stream: ${logStreamType} please import @ikegps/core-log-${logStreamType}`);
            }
            const logStream = factory.create(logLevel, logConfig);
            streams.push(logStream);
        }
        const logger = IkeLog.createLogger({
            name: options.name,
            streams,
            hostname: options.hostname,
            keys: options.keys,
        });
        config.register(logger);
        return logger;
    }
    static register(factory) {
        FACTORIES[factory.type] = factory;
    }
}
exports.IkeLog = IkeLog;
const ConsoleStreamFactory = {
    type: log_streams_1.IkeLogStreamType.CONSOLE,
    create: (level) => new bblog_stream_console_1.ConsoleLogStream(level),
};
IkeLog.register(ConsoleStreamFactory);
//# sourceMappingURL=index.js.map